import React, { useState } from 'react';
import './ConfigPlesk.css';

const ConfigPlesk = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'استارتر',
      price: '۲۵۰',
      unit: 'هزار تومان',
      features: ['نصب Plesk', 'تنظیمات پایه', 'پشتیبانی ۲۴/۷'],
      popular: false,
    },
    {
      tier: 'پیشرفته',
      price: '۴۵۰',
      unit: 'هزار تومان',
      features: ['نصب Plesk', 'تنظیمات امنیتی', 'بهینه‌سازی عملکرد', 'پشتیبانی ۲۴/۷'],
      popular: true,
    },
    {
      tier: 'حرفه‌ای',
      price: '۷۵۰',
      unit: 'هزار تومان',
      features: ['نصب Plesk', 'تنظیمات امنیتی پیشرفته', 'بهینه‌سازی کامل', 'مدیریت وب‌سایت‌ها', 'پشتیبانی ۲۴/۷', 'مشاوره تخصصی'],
      popular: false,
    },
  ];

  const features = [
    {
      icon: '🌐',
      title: 'کنترل پنل Plesk قدرتمند',
      desc: 'Plesk یکی از قدرتمندترین کنترل پنل‌های مدیریت وب‌سایت است که روی سرورهای ویندوز و لینوکس قابل نصب است. با نصب و راه‌اندازی حرفه‌ای Plesk، می‌توانید به راحتی وب‌سایت‌ها، دامنه‌ها، ایمیل‌ها و پایگاه داده‌ها را مدیریت کنید.',
    },
    {
      icon: '🪟',
      title: 'پشتیبانی از ویندوز و لینوکس',
      desc: 'Plesk برخلاف بسیاری از کنترل پنل‌ها، روی هر دو سیستم‌عامل ویندوز و لینوکس قابل نصب است. تیم ما کانفیگ Plesk را برای هر دو پلتفرم با بهترین تنظیمات انجام می‌دهد.',
    },
    {
      icon: '🛡️',
      title: 'امنیت پیشرفته و به‌روزرسانی خودکار',
      desc: 'Plesk با امکانات امنیتی پیشرفته، فایروال، محافظت در برابر حملات و به‌روزرسانی خودکار، امنیت وب‌سایت‌های شما را تضمین می‌کند. ما تنظیمات امنیتی را به صورت حرفه‌ای انجام می‌دهیم.',
    },
    {
      icon: '⚡',
      title: 'بهینه‌سازی عملکرد و سرعت',
      desc: 'با کانفیگ حرفه‌ای Plesk، عملکرد سرور شما به حداکثر می‌رسد. تنظیمات کش، بهینه‌سازی پایگاه داده و وب‌سرور، سرعت بارگذاری وب‌سایت‌های شما را افزایش می‌دهد.',
    },
  ];

  const faqs = [
    {
      q: 'Plesk چه تفاوتی با cPanel دارد و کدام یک برای من مناسب‌تر است؟',
      a: 'Plesk یکی از رقبای اصلی cPanel است که تفاوت‌های مهمی با آن دارد. Plesk روی هر دو سیستم‌عامل ویندوز و لینوکس قابل نصب است، در حالی که cPanel فقط روی لینوکس نصب می‌شود. Plesk دارای رابط کاربری مدرن‌تر و ساده‌تری است و بسیاری از کاربران آن را برای مدیریت وب‌سایت‌های وردپرسی ترجیح می‌دهند. همچنین Plesk امکانات پیشرفته‌تری برای توسعه‌دهندگان و برنامه‌نویسان دارد. انتخاب بین Plesk و cPanel به نیازها، سیستم‌عامل و سلیقه شما بستگی دارد.',
    },
    {
      q: 'آیا کانفیگ Plesk برای سرورهای ویندوز هم انجام می‌شود؟',
      a: 'بله، تیم افرسل کانفیگ Plesk را برای هر دو سیستم‌عامل ویندوز و لینوکس انجام می‌دهد. Plesk یکی از بهترین کنترل پنل‌ها برای سرورهای ویندوز است و با پشتیبانی از ASP.NET، MSSQL و IIS، گزینه‌ای ایده‌آل برای اپلیکیشن‌های دات‌نت و وب‌سایت‌های سازمانی محسوب می‌شود.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>کانفیگ سرور Plesk | نصب و راه‌اندازی حرفه‌ای | افرسل</h1>
        <p>خدمات حرفه‌ای نصب و راه‌اندازی Plesk روی سرورهای ویندوز و لینوکس. کانفیگ Plesk با بهترین تنظیمات امنیتی و عملکردی، مناسب برای هاستینگ‌های حرفه‌ای و سازمان‌ها.</p>
        <meta name="description" content="کانفیگ سرور Plesk با بهترین کیفیت از افرسل. نصب و راه‌اندازی Plesk روی ویندوز و لینوکس با تنظیمات امنیتی و بهینه‌سازی عملکرد." />
      </div>

      <section className="config-plesk-hero">
        <div className="config-plesk-hero-bg"></div>
        <div className="wrap">
          <div className="config-plesk-hero-content">
            <div className="config-plesk-badge">
              <span className="pulse-dot"></span>
              🌐 کانفیگ سرور Plesk
            </div>
            <h1 className="config-plesk-hero-title">
              کانفیگ <em>Plesk</em>
            </h1>
            <p className="config-plesk-hero-desc">
              خدمات حرفه‌ای نصب و راه‌اندازی کنترل پنل Plesk روی سرورهای ویندوز و لینوکس. 
              با کانفیگ Plesk، مدیریت وب‌سایت‌ها، دامنه‌ها، ایمیل‌ها و پایگاه داده‌ها به ساده‌ترین شکل ممکن انجام می‌شود. 
              تنظیمات امنیتی پیشرفته و بهینه‌سازی عملکرد برای بهترین تجربه کاربری.
            </p>
            <div className="config-plesk-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">ویندوز/لینوکس</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="config-plesk-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های کانفیگ Plesk</span>
            <h2 className="sec-h">پلن <em>مناسب</em> نیاز خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع کانفیگ Plesk با قیمت‌های رقابتی و خدمات متنوع برای هر نوع کسب‌وکار.</p>
          </div>
          <div className="config-plesk-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`config-plesk-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="config-plesk-popular-badge">پرفروش‌ترین</span>}
                <div className="config-plesk-plan-tier">{plan.tier}</div>
                <div className="config-plesk-plan-price">
                  <span className="config-plesk-plan-num">{plan.price}</span>
                  <span className="config-plesk-plan-unit">{plan.unit}</span>
                </div>
                <ul className="config-plesk-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="config-plesk-order-btn" onClick={() => scrollTo('contact')}>درخواست کانفیگ</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="config-plesk-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای کانفیگ Plesk</span>
            <h2 className="sec-h">چرا <em>کانفیگ Plesk</em> با افرسل؟</h2>
            <p className="sec-p">کانفیگ Plesk با بهترین تنظیمات برای مدیریت حرفه‌ای وب‌سایت‌ها.</p>
          </div>
          <div className="config-plesk-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="config-plesk-feature-card">
                <span className="config-plesk-feature-icon">{feature.icon}</span>
                <h3 className="config-plesk-feature-title">{feature.title}</h3>
                <p className="config-plesk-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="config-plesk-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
            <p className="sec-p">پاسخ سوالات رایج درباره کانفیگ و استفاده از Plesk.</p>
          </div>
          <div className="config-plesk-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="config-plesk-faq-item">
                <div className="config-plesk-faq-q">{faq.q}</div>
                <div className="config-plesk-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="config-plesk-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              کانفیگ <em>Plesk</em> را به ما بسپارید
            </h2>
            <p className="cta-desc">
              با تیم ما تماس بگیرید تا بهترین کانفیگ Plesk را برای سرور شما انجام دهیم. 
              نصب و راه‌اندازی حرفه‌ای با بهترین تنظیمات امنیتی و عملکردی.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>درخواست کانفیگ</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ConfigPlesk;
